import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/drivewayPatterns/blog-driveway-pattern-banner.jpg";
import img001 from "../../images/drivewayPatterns/blog-driveway-pattern-002.jpg";
import img002 from "../../images/drivewayPatterns/blog-driveway-pattern-003.jpg";
import img003 from "../../images/drivewayPatterns/blog-driveway-pattern-006.jpg";
import b1 from "../../images/drivewayPatterns/1b-running-bond.jpg";
import b2 from "../../images/drivewayPatterns/2b-herringbone-90.jpg";
import b4 from "../../images/drivewayPatterns/4b-I-pattern.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const DrivewayPatternsData = {
  title: "Our 3 Favorite Driveway Brick Paving Patterns",
  image: banner,
  destination: "/blog/3-favorite-driveway-brick-paving-patterns",
  date: "August 7, 2016",
  categories: ["blog", "driveways", "paving-stones"],
};

const DrivewayPatterns = () => {
  const blog = [DrivewayPatternsData];

  return (
    <>
      <SEO
        title="Our 3 Favorite Driveway Brick Paving Patterns - How to Choose"
        description="Your driveway can beautify your property and increase its value. With such a great improvement, it’s important to create a driveway that is truly unique."
        profileURL={
          "https://www.pacificpavingstone.com/blog/3-favorite-driveway-brick-paving-patterns"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/3-favorite-driveway-brick-paving-patterns",
          headline:
            "Our 3 Favorite Driveway Brick Paving Patterns - How to Choose",
          description:
            "Your driveway can beautify your property and increase its value. With such a great improvement, it’s important to create a driveway that is truly unique.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-driveway-pattern-003.736d7559.jpg",
          },
          datePublished: "2016-08-07",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              A driveway may be easily overlooked, but it’s one of your
              property’s best chances for both curb appeal and frequent
              functional use. If you assume that driveways all look the same,
              you couldn’t be more wrong.
              <br />
              <br />
              Your driveway is one of the first things that visitors will see
              upon arriving. It can commonly be one of the most frequently used
              surfaces outside of your home. Your driveway can not only beautify
              your property, but even increase its value. With such a great
              improvement, it’s important to create a driveway that is truly
              unique.
            </p>

            <h4>Choosing Materials for Driveway Brick Paving</h4>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img001} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Paving stones (or pavers) are hands down, the best driveway
                  paving material. There are a few major manufacturers of paving
                  stones to consider. Each brand has a variety of products to
                  choose from. These materials will vary in their form and
                  style. Similar products will be called by different names
                  depending upon which brand your driveway paving company uses.
                </p>
              </div>
            </div>
            <p>
              Some driveway brick paving materials will resemble cobblestones or
              old world styles. These materials can vary in textures both on
              edges and surface. Distressed edges and a time-worn look resembles
              the hand-laid stones of Mediterranean villas or European
              courtyards.
              <br />
              <br />
              Other pavingstones may resemble bricks with smooth, tight
              geometric shapes. These rectangular stones resemble traditional
              bricks and allow for many unique driveway brick paving patterns.
            </p>

            <h4>Which Driveway Brick Paving Patterns are Right for You?</h4>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img002} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Designing unique driveway brick paving patterns are just one
                  way to give your surface a unique look. Almost anything is
                  possible with the right pavingstone selection and an expert
                  plan.
                  <br />
                  <br />
                  Choosing the right driveway brick paving patterns will help
                  complement your home instead of looking out of place.
                </p>
              </div>
            </div>
            <p>
              Driveway brick paving patterns should complement your property’s
              architecture. If you’re unsure of the options, ask your driveway
              paving company to show you pictures online or in a manufacturer
              catalog.
            </p>

            <ul>
              <li>
                <span className="text-blue">Contemporary Homes:</span> For homes
                with crisp, straight lines, geometric paving stones with a
                simple pattern will look best.
              </li>
              <li>
                <span className="text-blue">Colonial Homes:</span> Pavers that
                resemble the clay bricks from centuries ago are the best choice
                for a Colonial home. However, manufactured concrete pavers can
                support more weight and are more durable than clay bricks.
              </li>
              <li>
                <span className="text-blue">Old-World Homes:</span> If your home
                is Victorian, Mediterranean or a style that looks straight out
                of centuries ago, using a less formal, classic paver will
                continue the old-world feel.
              </li>
            </ul>
            <h4>Our 3 Favorite Driveway Brick Paving Patterns</h4>
            <p>
              The best driveway brick paving patterns are chosen primarily by
              their ability to endure, over mere aesthetics. You could pick a
              pretty pattern, but if your driveway starts to settle under the
              shifting weight of moving vehicles, you’ll be facing costly
              repairs. Choosing the right pattern is crucial.
              <br />
              <br />
              Driveway brick paving patterns can be further customized by using
              a closely matching color blend to give additional appeal and also
              by adding border courses of paving stones to frame in areas.
              However, these 3 driveway brick paving patterns are the
              best-performing options:
            </p>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={b4} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  <span className="text-blue">I-Pattern:</span> If you’re
                  looking for driveway brick paving patterns that give a
                  somewhat random look but want a good solution, choose the
                  I-Pattern. This configuration gets its name from the shape of
                  the capital letter “I” throughout the pattern. By using a few
                  different sizes of paving stones, the I-Pattern will make a
                  durable and unique driveway.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={b1} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  <span className="text-blue">Running Bond:</span> This is a
                  favorite for the classic, old-world style home. The Running
                  Bond mimics the look of European cobblestone streets more than
                  other driveway brick paving patterns. Just be sure your
                  installer runs the bond across the driveway, not along the
                  length. Avoiding long runs will help to mask any small
                  irregularities in the lines.
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-5">
                <img src={b2} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  <span className="text-blue">Herringbone:</span> This is both
                  the most versatile and the most durable of driveway brick
                  paving patterns. Rectangular paving stones are arranged in
                  either a 45 or 90 degree fashion, revealing a beautiful
                  zig-zag pattern. This pattern is extremely durable because of
                  its ability to displace weight of vehicle tires from one stone
                  to the next.
                </p>
              </div>
            </div>

            <h4>Help with Driveway Brick Paving Patterns</h4>
            <p>
              We understand that it can be both an exciting and frustrating
              process to pick the right paving stone materials, driveway brick
              paving patterns, and a reputable driveway paving contractor.
            </p>
            <div className="row">
              <div className="col-12 col-md-5">
                <img src={img003} alt="Feature" />
              </div>
              <div className="col-12 col-md-7">
                <p>
                  Installing a new pavingstone driveway is a great investment
                  for your property so you want to make sure that the company
                  you’re dealing with is providing you with the best solution.
                  <br />
                  <br />
                  Before the stage of product selection and design, make sure
                  the company you’re dealing with is licensed and carries ample
                  insurance coverage. Ask them to share reviews, testimonials,
                  and pictures of finished projects in your area.
                </p>
              </div>
            </div>
            <p>
              Pacific Pavingstone has designed and installed tens of thousands
              of uniquely beautiful driveways of all shapes, colors, and styles.
              If you have a firm opinion or are completely open to suggestions,
              one of our experienced team would be happy to discuss your
              options.{" "}
              <Link to="/contact-us">
                Please contact us for a free consultation.
              </Link>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(DrivewayPatterns);
